import { render } from "./passenger.vue?vue&type=template&id=0fbc4cde&scoped=true"
import script from "./passenger.vue?vue&type=script&lang=js"
export * from "./passenger.vue?vue&type=script&lang=js"

import "./passenger.vue?vue&type=style&index=0&id=0fbc4cde&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbc4cde"],['__file',"src/views/my/passenger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fbc4cde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fbc4cde', __exports__)) {
    console.log('reload')
    api.reload('0fbc4cde', __exports__)
  }
  
  module.hot.accept("./passenger.vue?vue&type=template&id=0fbc4cde&scoped=true", () => {
    console.log('re-render')
    api.rerender('0fbc4cde', render)
  })

}


export default __exports__